import { get, post, patch, del } from "../apiClient";
import { API_BASE_URL } from "../config";

const exitService = {
    getExitRequests: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        const url = `/exit-test${queryString ? `?${queryString}` : ""}`;
        return await get(url);
    },

    getExitRequestById: async (id) => {
        return await get(`/exit-test/${id}`);
    },

    getExitRequestByEmployeeId: async (employeeId) => {
        try {
            const response = await get(`/exit-test?employeeId=${employeeId}`);
            if (response.responseCode === 200 && response.data.exitRequests.length > 0) {
                return {
                    success: true,
                    data: response.data.exitRequests[0]
                };
            }
            return {
                success: false,
                error: "Exit request not found"
            };
        } catch (error) {
            return {
                success: false,
                error: error.message
            };
        }
    },

    createExitRequest: async (data) => {
        return await post("/exit-test", data);
    },

    approveExitRequest: async (id, data) => {
        return await patch(`/exit-test/${id}/approve`, data);
    },

    rejectExitRequest: async (id, data) => {
        return await patch(`/exit-test/${id}/reject`, data);
    },

    allowWithdrawal: async (id, data) => {
        return await patch(`/exit-test/${id}/allow-withdrawal`, data);
    }
};

export default exitService;
